import { createJourneyRouter } from '@cash-web/shared-journey-feature-main'

import { activityJourneyRoutes } from './lib/activity/routes'
import { bitcoinJourneyRoutes } from './lib/bitcoin/routes'
import { cardJourneyRoutes } from './lib/card/routes'
import { cashJourneyRoutes } from './lib/cash/routes'
import { cashtagJourneyRoutes } from './lib/cashtag/routes'
import { devicesJourneyRoutes } from './lib/devices/routes'
import { documentsJourneyRoutes } from './lib/documents/routes'
import { errorJourneyRoutes } from './lib/error/routes'
import { flowJourneyRoutes } from './lib/flow/routes'
import { investingJourneyRoutes } from './lib/investing/routes'
import { oonJourneyRoutes } from './lib/oon/routes'
import { payAndRequestJourneyRoutes } from './lib/pay-and-request/routes'
import { paychecksJourneyRoutes } from './lib/paychecks/routes'
import { poolsJourneyRoutes } from './lib/pools/routes'
import { savingsJourneyRoutes } from './lib/savings/routes'
import { settingsJourneyRoutes } from './lib/settings/routes'
import { stocksJourneyRoutes } from './lib/stocks/routes'
import { supportJourneyRoutes } from './lib/support/routes'
import { taxesJourneyRoutes } from './lib/taxes/routes'
import { mergeJourneyRoutes } from './lib/utils/mergeJourneyRoutes'

export const rawJourneyRoutes = [
  ...errorJourneyRoutes,
  ...activityJourneyRoutes,
  ...bitcoinJourneyRoutes,
  ...cardJourneyRoutes,
  ...cashJourneyRoutes,
  ...devicesJourneyRoutes,
  ...documentsJourneyRoutes,
  ...savingsJourneyRoutes,
  ...investingJourneyRoutes,
  ...settingsJourneyRoutes,
  ...payAndRequestJourneyRoutes,
  ...paychecksJourneyRoutes,
  ...poolsJourneyRoutes,
  ...stocksJourneyRoutes,
  ...flowJourneyRoutes,
  ...cashtagJourneyRoutes,
  ...oonJourneyRoutes,
  ...supportJourneyRoutes,
  ...taxesJourneyRoutes,
]

export const journeyRoutes = mergeJourneyRoutes(rawJourneyRoutes)

export const journeyRouter = createJourneyRouter(journeyRoutes)
